var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"title":_vm.isStringArray ? _vm.StringArrayData : _vm.data}},[(!_vm.isStringArray)?_c('span',[_vm._v(" "+_vm._s(_vm.data)+" ")]):_vm._e(),_vm._v(" "),(_vm.isStringArray)?_c('span',[_vm._v(" "+_vm._s(_vm.StringArrayData)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }